import { useState } from "react";
import StorageList from "./StorageList";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";
import { Radio, Segmented } from "antd";
import { useSearchParams } from "react-router";
import { StorageHistory } from "./StorageHistory";
import { MdFormatListBulleted, MdHistory } from "react-icons/md";

enum Show_mode {
  list = "Liste",
  history = "Historiques",
}

const SHOW_MODE_OPTIONS = [
  {
    icon: (
      <MdFormatListBulleted
        style={{
          fontSize: "20px",
        }}
      />
    ),
    value: Show_mode.list,
  },
  {
    icon: (
      <MdHistory
        style={{
          fontSize: "20px",
        }}
      />
    ),
    value: Show_mode.history,
  },
];

export const StoragePages = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const initialView = searchParams.get("mode") || Show_mode.list;

  const [selectedMode, setSelectedMode] = useState<string>(initialView);

  const handleChangeViewMode = (value: any) => {
    // const mode = value?.target?.value;
    setSelectedMode(value);
    setSearchParams({ mode: value });
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-end ">
        <TitleHeader
          title={
            selectedMode === Show_mode.list
              ? "Entreposage"
              : "Entreposage : Historiques"
          }
        />

        <div className=" ">
          <div className="flex-full mt-4">
            <Segmented
              // size={size}
              shape="round"
              value={selectedMode}
              onChange={handleChangeViewMode}
              options={SHOW_MODE_OPTIONS}
            />
            {/* <Radio.Group
              block
              options={SHOW_MODE_OPTIONS}
              optionType="button"
              buttonStyle="solid"
              // defaultValue={}
              value={selectedMode}
              onChange={handleChangeViewMode}
            /> */}
          </div>
        </div>
      </div>
      {selectedMode === Show_mode.list ? <StorageList /> : <StorageHistory />}
    </div>
  );
};
